module.exports = __webpack_public_path__ + "img/settings.2cc4dd1d.svg";